// eslint-disable-next-line
export const formatPhoneNumber = {
  methods: {
    formatPhoneNumber(number) {
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
};
